type TypeProps = {
  validator: string;
  status: string;
  timeLeft: string;
  spaceLeft: string;
  estimated: string;
};

import { onGoingDelegationRows } from './data';

import GridTable from 'components/grid-table/grid-table';
import { columnsOngoingDelegation } from 'utils/columns-table';

const OngoingDelegationPoolsTable = () => {
  return (
    <GridTable<TypeProps>
      uniqueKey="ongoing-delegation"
      hover
      cols={5}
      variant="delegation"
      loading={false}
      columns={columnsOngoingDelegation}
      hasMore={false}
      data={onGoingDelegationRows}
    />
  );
};

export default OngoingDelegationPoolsTable;
